export const questions: {[key: number]: {question: string; answers: string[]; correctAnswer: number}[]} = {
	10: [
		{
			question: 'قرآن در چه ماهی نازل شده است؟',
			answers: ['شعبان', 'رجب', 'محرم', 'رمضان'],
			correctAnswer: 3
		},
		{
			question: 'سقاخانه معروف اسماعیل طلا در کدام صحن حرم قرار دارد؟',
			answers: ['صحن جمهوری اسلامی', 'صحن آزادی', 'صحن انقلاب اسلامی', 'صحن غدیر'],
			correctAnswer: 2
		},
		{
			question: 'کنیه امام رضا (ع) کدام است؟',
			answers: ['اباعبدالله', 'اباالحسن', 'اباالقاسم', 'اباالجواد'],
			correctAnswer: 1
		}
	],
	11: [
		{
			question: 'امام رضا علیه السلام در شهر نیشابور کدام حدیث را بیان کردند؟',
			answers: ['حدیث منزلت', 'حدیث سلسله الذهب', 'حدیث حدیث ثقلین', 'حدیث کساء'],
			correctAnswer: 1
		},
		{
			question: 'حرم مطهر رضوی چند چایخانه دارد؟',
			answers: ['دو چایخانه', 'سه چایخانه', 'چهار چایخانه ', 'پنج چایخانه'],
			correctAnswer: 2
		},
		{
			question: 'کدام یک از چهار معصوم، در ماه رمضان به شهادت رسیدند؟',
			answers: ['حضرت زهرا (ع)', 'امام حسن (ع)', 'امام رضا(ع)', ' حضرت علی (ع)'],
			correctAnswer: 3
		}
	],
	12: [
		{
			question: 'چه کسی دستور داد امام رضا (ع) را ولیعهد خود قرار دهند؟',
			answers: ['هارون الرشید', 'مأمون', 'متوکل', 'امین'],
			correctAnswer: 1
		},
		{
			question: 'کدام یک نام ورودی حرم رضوی نیست؟',
			answers: ['درب باب الجواد', 'درب باب الرضا', 'درب باب المراد ', 'درب باب الکاظم'],
			correctAnswer: 2
		},
		{
			question: 'در کدام شب از ماه رمضان، قرآن کریم بر پیامبر اسلام (ص) نازل شد؟',
			answers: ['شب اول', 'نیمه ماه رمضان', 'شب قدر ', 'شب عید فطر'],
			correctAnswer: 2
		}
	],
	15: [
		{
			question: 'مرقد مطهر پدر بزرگوار امام رضا (ع) در کدام شهر است؟',
			answers: ['مدینه', 'کاظمین', 'سامرا', 'هیچکدام'],
			correctAnswer: 1
		},
		{
			question: 'کدام یک در حرم رضوی نیست؟',
			answers: ['دانشگاه رضوی', 'زائر سرا', 'کتابخانه مرکزی', 'مهمانسرا'],
			correctAnswer: 1
		},
		{
			question: 'کدام یک از اعمال زیر در ماه رمضان مستحب است؟',
			answers: ['خواندن دعای افتتاح', 'افطار دادن به روزه‌داران', 'خواندن قرآن', 'همه موارد'],
			correctAnswer: 3
		}
	],
	17: [
		{
			question: 'اصلی ترین پیام حدیث «سلسله الذهب» در کدام گزینه نهفته است؟',
			answers: ['توحید و نبوت', 'توحید و معاد', 'توحید و امامت', 'توحید و عدل'],
			correctAnswer: 2
		},
		{
			question: 'کدام یک، دیگر اسم یکی از  صحن های حرم رضوی نیست؟',
			answers: ['صحن امام حسن مجتبی (ع)', 'صحن هدایت', 'صحن غدیر', 'صحن کوثر'],
			correctAnswer: 1
		},
		{
			question: 'روزه گرفتن در روز عید فطر چه حکمی دارد؟',
			answers: ['مستحب', 'مکروه', 'حرام', 'مباح'],
			correctAnswer: 2
		}
	],
	19: [
		{
			question: 'امام رضا (ع) در کدام شهر به دنیا آمدند؟',
			answers: ['مکه', 'مدینه', 'کوفه', 'بغداد'],
			correctAnswer: 1
		},
		{
			question: 'محل نقاره خانه حرم رضوی در کجاست؟',
			answers: ['ورودی صحن ازادی', 'ورودی صحن انقلاب اسلامی', 'ورودی صحن غدیر', 'ورودی صحن کوثر'],
			correctAnswer: 1
		},
		{
			question: 'کدام یک از موارد زیر روزه را باطل می‌کند؟',
			answers: ['خوردن و آشامیدن عمدی', 'خوابیدن در طول روز', 'نوشیدن آب به‌صورت سهوی', 'حمام رفتن'],
			correctAnswer: 0
		}
	],
	27: [
		{
			question: 'کدام یک از القاب زیر به امام رضا (ع) تعلق دارد؟',
			answers: ['عالم آل محمد', 'غریب الغربا', 'ضامن آهو', 'همه موارد'],
			correctAnswer: 3
		},
		{
			question: 'ضریح فعلی حرم مطهر امام رضا (ع) چندمین بعد از شهادت حضرت است؟',
			answers: ['سومین ضریح', 'چهارمین ضریح', 'پنجمین ضریح', 'ششمین ضریح'],
			correctAnswer: 2
		},
		{
			question: 'کدام یک از شب‌های زیر از شب‌های قدر محسوب نمی‌شود؟',
			answers: ['شب ۱۹ رمضان', 'شب ۲۱ رمضان', 'شب ۲۳ رمضان', 'شب ۲۵ رمضان'],
			correctAnswer: 3
		}
	],
	28: [
		{
			question: 'مادر گرامی امام رضا (ع) چه نام داشتند؟',
			answers: ['نرجس خاتون', 'نجمه خاتون', 'حمیده خاتون', 'فاطمه بنت اسد'],
			correctAnswer: 1
		},
		{
			question: 'اعتکاف‌های حرم مطهر رضوی کجا برگزار می‌شود؟',
			answers: ['مسجد گوهرشاد', 'مدرسه پریزاد', 'رواق امام خمینی (ره)', 'رواق دارالحجه'],
			correctAnswer: 0
		},
		{
			question: 'اگر فردی عمداً روزه ماه رمضان را بدون دلیل بخورد، کفاره آن چیست؟',
			answers: ['گرفتن ۳۰ روز روزه قضا', 'اطعام ۶۰ فقیر یا گرفتن ۶۰ روز روزه', 'خواندن نماز استغفار', 'پرداخت صدقه'],
			correctAnswer: 1
		}
	],
	29: [
		{
			question: 'ابن الرضا لقب کدام امام نیست؟',
			answers: ['امام رضا (ع)', 'امام جواد (ع)', 'امام هادی (ع)', 'امام حسن عسکری (ع)'],
			correctAnswer: 0
		},
		{
			question: 'بزرگ ترین صحن حرم مطهر رضوی چه نام دارد؟',
			answers: ['صحن انقلاب اسلامی', 'صحن پیامبر اعظم (ص)', 'صحن جمهوری اسلامی', 'صحن امام حسن (ع)'],
			correctAnswer: 1
		},
		{
			question: 'کدام یک از اعمال زیر در روزهای ماه رمضان مکروه است؟',
			answers: ['مسواک زدن', 'ورزش کردن شدید', 'خوابیدن طولانی', 'نوشیدن آب با فراموشی'],
			correctAnswer: 1
		}
	]
};
